import { Box, Typography } from "@braintrust/braintrust-ui-components";

import type { OpenProfileCompletionSequenceButtonProps } from "./open-profile-completion-sequence-button";
import { OpenProfileCompletionSequenceButton } from "./open-profile-completion-sequence-button";

type ProfileCompletionFeedbackLabelProps =
  OpenProfileCompletionSequenceButtonProps & {
    customNamePrefix?: string;
    progress: number;
  };

export const ProfileCompletionFeedbackLabel = ({
  number,
  name,
  customNamePrefix,
  pluralize,
  progress,
}: ProfileCompletionFeedbackLabelProps) => {
  return (
    <Box sx={{ display: "flex", width: 1 }}>
      <Typography
        component="p"
        variant="paragraph"
        color="inherit"
        sx={{
          flexGrow: 1,
          pr: 1,
          fontSize: "11px !important",
          lineHeight: "26px !important",
        }}
      >
        {customNamePrefix ?? "Add"} {number ? `${number}` : ""}{" "}
        <OpenProfileCompletionSequenceButton
          name={name}
          pluralize={pluralize}
          number={number}
        />
      </Typography>

      <Typography
        component="p"
        sx={{ fontSize: "11px !important", lineHeight: "26px !important" }}
      >
        {progress}%
      </Typography>
    </Box>
  );
};

export const profileCompletionFeedbackLabelPropMap: Record<
  EnumType<typeof ENUMS.ProfileCompletionArea>,
  Partial<ProfileCompletionFeedbackLabelProps>
> = {
  [ENUMS.ProfileCompletionArea.FreelancerFullNameCompletionDetail]: {
    customNamePrefix: "Add a",
    name: "Full Name",
  },
  [ENUMS.ProfileCompletionArea.FreelancerLocationCompletionDetail]: {
    customNamePrefix: "Add a",
    name: "Location",
  },
  [ENUMS.ProfileCompletionArea.FreelancerRoleCompletionDetail]: {
    customNamePrefix: "Add your",
    name: "Role",
  },
  [ENUMS.ProfileCompletionArea.FreelancerSkillCompletionDetail]: {
    name: "Skill",
    customNamePrefix: "Add your",
    pluralize: true,
  },
  [ENUMS.ProfileCompletionArea.FreelancerSuperPowersCompletionDetail]: {
    name: "Top skill",
    pluralize: true,
  },
  [ENUMS.ProfileCompletionArea.FreelancerWorkExperienceCompletionDetail]: {
    name: "Work Experience",
  },
};
